import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY } from './common';

const routes = [
    {
        matchRegex: '/PurchaseOrderTemplate/Detail/:id',
        name: 'Purchase Order Template - Detail',
        slots: [
            SLOT_KEY.SLOT_V_TABLE_COLUMN, 
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_SECTION,
            SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN,
        ],
        image: PreviewDetailImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                {
                    key: 'MARKETPLACE_EVENT_FETCH_LIST_SUCCESS',
                    label: 'Trigger Fetch List Successfully',
                },
                {
                    key: 'MARKETPLACE_EVENT_DELETE_PO_LINE_SUCCESS',
                    label: 'After Delete PO Line Success',
                },
                {
                    key: 'MARKETPLACE_EVENT_UPDATE_PO_LINE_SUCCESS',
                    label: 'After Update PO Line Success',
                },
               
            ],
        },
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'po-item-unit', label: 'PO Item Unit' },
            ],
            [SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN]: [
                { key: 'table-link-supplier-header', label: 'Table "Link supplier" header' },
                { key: 'table-link-supplier-body', label: 'Table "Link supplier" body' }
            ],
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'po-template-items-table', label: 'PO Template Items table' },
            ],
        },
        replaceElements: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'quantity', label: 'PO Item Quantity' },
            ],
        },
    },
]

export default routes;